document.addEventListener('DOMContentLoaded', function() {
    const toggles = document.querySelectorAll('.parent-collection .collection-toggle');

    toggles.forEach(toggle => {
      toggle.addEventListener('click', function() {
        const parent = this.parentElement;
        const isOpen = parent.classList.toggle('open');

        if (isOpen) {
          const items = parent.querySelector('.subcollection-items');
          items.style.maxHeight = items.scrollHeight + 'px';

          toggles.forEach(otherToggle => {
            if (otherToggle !== this) {
              const otherParent = otherToggle.parentElement;
              otherParent.classList.remove('open');
              const otherItems = otherParent.querySelector('.subcollection-items');
              if (otherItems) {
                otherItems.style.maxHeight = 0;
              }
            }
          });
        } else {
          const items = parent.querySelector('.subcollection-items');
          items.style.maxHeight = 0;
        }
      });
    });
  });